module.exports = __webpack_public_path__ + "img/project-albertonl.com.21d920f8.png";